export default "__VITE_ASSET__kFn$s0iQ__"